<div class="modal-body">
    <div>{{prompt}}</div>
</div>
<div class="modal-footer">
    <button type="submit" class="btn btn-primary" focus-me [ngClass]="okBtnClass" (click)="confirmModal()">@if(okBtnIcon) {<fa-icon [icon]="okBtnIcon"></fa-icon> } {{okBtnText}}</button>
</div>